export default __webpack_public_path__ + "static/media/No9Closed.a5db0c16.jpg";